module.exports = __webpack_public_path__ + "media/images/about-us/facebook-ed9920b224709636fcc16f9769a937d8.svg";